import { breakpoints, colors } from '../variables'

import React from 'react'
import Wave from './wave'
import { css } from '@emotion/react'

export default ({ blue = false, className, children, last = false }) => (
  <>
    <div
      css={[
        css`
          background-color: ${blue ? colors.blue5 : 'none'};
          padding-left: 20px;
          padding-right: 20px;
          padding-top: ${blue ? 'calc(40px + 5vw)' : '0'};
          position: relative;
          width: 100%;
          z-index: 2;

          @media (min-width: ${breakpoints.tablet}px) {
            padding-bottom: ${blue ? '0' : '0'};
            padding-left: 40px;
            padding-right: 40px;
            padding-top: ${blue ? 'calc(60px + 5vw)' : '0'};
          }
        `,
        className,
      ]}
    >
      <div
        css={css`
          padding: ${blue ? '0 0 40px' : '0'};
          max-width: 1200px;
          position: relative;
          z-index: 1;

          @media (min-width: ${breakpoints.tablet}px) {
            padding: ${blue ? '0 0 60px' : '0'};
          }

          ${last
            ? css`
                @media (min-width: ${breakpoints.laptop}px) {
                  padding: 0;
                  margin: ${blue ? '0 auto 7.5vw' : '0 auto'};
                }
              `
            : css`
                @media (min-width: ${breakpoints.laptop}px) {
                  margin: ${blue ? '0 auto -20vw' : '0 auto'};
                }
              `}
        `}
      >
        {children}
      </div>

      {blue && <Wave position="top" />}
    </div>

    {blue && <Wave position="bottom" />}
  </>
)
